import React from "react";
/**
 * Used instead of MUI's own version to avoid hydration errors
 *
 * @see https://github.com/chakra-ui/chakra-ui/issues/3580
 */
export const useMediaQuery = (mediaQueryString) => {
    const [matches, setMatches] = React.useState(null);
    React.useEffect(() => {
        if (!window || typeof window.matchMedia !== "function") {
            setMatches(false);
            return;
        }
        const str = mediaQueryString.replace("@media ", "");
        const mediaQueryList = window.matchMedia(str);
        const listener = () => setMatches(!!mediaQueryList.matches);
        listener();
        if (!mediaQueryList.addEventListener || typeof mediaQueryList.addEventListener !== "function") {
            return;
        }
        mediaQueryList.addEventListener("change", listener);
        return () => mediaQueryList.removeEventListener("change", listener);
    }, [mediaQueryString]);
    return matches;
};
//# sourceMappingURL=use-media-query.js.map